import React from "react";
import { Link } from "react-router-dom";
import { useTranslation, formatEuro } from "../../../../i18n";
import { MaterialIcon } from "./checkoutUi";

const PaymentOrderSummary = ({ checkout }) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full flex-col gap-gutter">
      <div className="h-full rounded-xl border border-outline-variant/30 bg-surface-container-lowest p-stack-lg shadow-soft">
        <span className="mb-4 block font-label-caps text-label-caps text-on-primary-container">
          {t("payment.orderSummary")}
        </span>

        <div className="mb-6 flex items-start justify-between">
          <div>
            <h2 className="font-headline-lg text-headline-lg text-on-surface">
              {checkout.title}
            </h2>
            {checkout.subtitle && (
              <p className="mt-1 font-body-md text-on-surface-variant">
                {checkout.subtitle}
              </p>
            )}
          </div>
        </div>

        <div className="space-y-4 border-y border-outline-variant/30 py-6">
          {checkout.lineItems.map((row, index) => (
            <div key={`${row.label}-${index}`}>
              <div className="flex justify-between font-body-lg text-on-surface">
                <span className="flex items-center gap-2">
                  {row.label}
                  {row.amount === 0 && (
                    <MaterialIcon name="info" className="text-[16px] text-secondary" />
                  )}
                </span>
                <span
                  className={[
                    row.amount === 0 ? "font-medium text-secondary" : "font-semibold",
                  ].join(" ")}
                >
                  {row.amount === 0 ? t("payment.included") : formatEuro(row.amount)}
                </span>
              </div>
              {row.detail && (
                <p className="text-label-sm text-on-surface-variant">{row.detail}</p>
              )}
            </div>
          ))}
        </div>

        <div className="mt-6">
          <div className="mb-1 flex items-center justify-between">
            <span className="font-headline-md text-headline-md text-on-surface">
              {t("payment.totalDue")}
            </span>
            <span className="font-headline-xl text-headline-xl text-secondary">
              {formatEuro(checkout.total)}
            </span>
          </div>
          {checkout.recurring && (
            <p className="text-label-sm text-on-surface-variant">
              {t("payment.billedMonthlyCancel")}
            </p>
          )}
        </div>

        <div className="mt-stack-lg space-y-3 border-t border-outline-variant/30 pt-stack-lg">
          <div className="flex items-center gap-3 font-body-md text-on-surface-variant">
            <MaterialIcon
              name="verified_user"
              filled
              className="text-[20px] text-secondary"
            />
            <span>{t("payment.secureSsl")}</span>
          </div>
          <div className="flex items-center gap-3 font-body-md text-on-surface-variant">
            <MaterialIcon
              name="description"
              filled
              className="text-[20px] text-secondary"
            />
            <span>{t("payment.vatInvoice")}</span>
          </div>
        </div>

        <div className="relative mt-12 overflow-hidden rounded-lg bg-surface-container p-6">
          <div className="relative z-10">
            <h4 className="mb-2 font-headline-md text-headline-md text-primary">
              {t("payment.needAssistance")}
            </h4>
            <p className="mb-4 font-body-md text-on-surface-variant">
              {t("payment.support24")}
            </p>
            <Link
              to="/dashboard/client/support"
              className="flex items-center gap-1 font-label-sm font-semibold text-secondary hover:underline"
            >
              {t("payment.contactSupport")}
              <MaterialIcon name="arrow_forward" className="text-[16px]" />
            </Link>
          </div>
          <div className="absolute -bottom-4 -right-4 opacity-5">
            <MaterialIcon name="support_agent" className="text-[120px]" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentOrderSummary;
